import React from 'react';
import { Check, Trash2 } from 'lucide-react';

const CommentModeration = ({ comments, onApproveComment, onDeleteComment }) => {
  return (
    <div className="bg-white/5 backdrop-blur-xl border border-white/20 rounded-2xl p-6">
      <h3 className="text-lg font-semibold text-foreground mb-6">Comment Moderation</h3>
      
      <div className="space-y-4">
        {comments.map((comment) => (
          <div key={comment.id} className="p-4 bg-white/5 rounded-xl">
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <div className="flex items-center space-x-2 mb-2">
                  <span className="text-foreground font-medium">{comment.username}</span>
                  <span className="text-xs text-muted-foreground">on {comment.content_title}</span>
                  {comment.flags > 0 && (
                    <span className="px-2 py-0.5 bg-red-500/20 text-red-400 text-xs rounded-full">
                      {comment.flags} flags
                    </span>
                  )}
                </div>
                <p className="text-foreground/80">{comment.text}</p>
              </div>
              <div className="flex space-x-2 ml-4">
                <button
                  onClick={() => onApproveComment(comment.id)}
                  className="p-2 bg-green-500/20 hover:bg-green-500/30 rounded-lg transition-colors"
                  title="Approve"
                  data-testid={`approve-comment-mod-${comment.id}`}
                >
                  <Check className="h-4 w-4 text-green-400" />
                </button>
                <button
                  onClick={() => onDeleteComment(comment.id)}
                  className="p-2 bg-red-500/20 hover:bg-red-500/30 rounded-lg transition-colors"
                  title="Delete"
                  data-testid={`delete-comment-mod-${comment.id}`}
                >
                  <Trash2 className="h-4 w-4 text-red-400" />
                </button>
              </div>
            </div>
          </div>
        ))}
        {comments.length === 0 && (
          <p className="text-center text-muted-foreground py-8">No flagged comments</p>
        )}
      </div>
    </div>
  );
};

export default CommentModeration;
